"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _ButtonGroup = _interopRequireDefault(require("elevate-ui/ButtonGroup"));

var items = [{
  value: "left",
  label: "Left"
}, {
  value: "center",
  label: "Center"
}, {
  value: "right",
  label: "Right"
}];

var Alignment = function Alignment() {
  return /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "alignment",
    name: "alignment",
    label: "Alignment",
    component: _ButtonGroup["default"],
    items: items,
    color: "secondary"
  });
};

var _default = Alignment;
exports["default"] = _default;